import { DefaultState } from '@src/redux/types'

import {
  CONFERENCE,
  CONFERENCE_ALL,
  CONFERENCE_ARTICLE_BY_ID,
  CONFERENCE_ARTICLE_ALL,
  CONFERENCE_ARTICLE_CREATE,
  CONFERENCE_CATEGORY_ALL,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [CONFERENCE]: DefaultState<`${typeof API.CONFERENCE}{id}`, 'get'>
  [CONFERENCE_ARTICLE_BY_ID]: DefaultState<`${typeof API.CONFERENCE_ARTICLE_BY_ID}{id}`, 'get'>
  [CONFERENCE_ARTICLE_CREATE]: DefaultState<`${typeof API.CONFERENCE_ARTICLE}`, 'post'>
  [CONFERENCE_ARTICLE_ALL]: DefaultState<`${typeof API.CONFERENCE_ARTICLE_ALL}`, 'get'>
  [CONFERENCE_CATEGORY_ALL]: DefaultState<`${typeof API.CONFERENCE_CATEGORY_ALL}`, 'get'>
  [CONFERENCE_ALL]: DefaultState<`${typeof API.CONFERENCE_ALL}`, 'get'>
} = () => ({
  [CONFERENCE]: defaultState(),
  [CONFERENCE_ARTICLE_BY_ID]: defaultState(),
  [CONFERENCE_ARTICLE_CREATE]: defaultState(),
  [CONFERENCE_ARTICLE_ALL]: defaultState(),
  [CONFERENCE_CATEGORY_ALL]: defaultState(),
  [CONFERENCE_ALL]: defaultState(),
})
